export default __webpack_public_path__ + "static/media/empty-image.3dc6aeed.svg";